/**
 * @description: 会员裂变关系链报表
 * @author: lyr
*/
<template>
    <div class="mr-hlbgx-report">
        <div class="list" v-show="!showDetail">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店" @change="changeShop">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="会员等级">
                    <el-select v-model="list_form.level" filterable clearable placeholder="请选择会员等级">
                        <el-option v-for="item in vip_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入内容" v-model="list_form.content">
                        <el-select class="el-slot-select" v-model="list_form.select" slot="prepend" placeholder="请选择">
                            <el-option label="会员手机号" value="vip_mobile"></el-option>
                            <el-option label="会员卡号" value="vip_card"></el-option>
                            <el-option label="会员姓名" value="vip_name"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="邀请人手机号">
                    <el-input v-model="list_form.invitation_mobile"  placeholder="请输入手机号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-row class="total-txt">
                <div class="item">奖励金总额合计：{{bonus_total}}</div>
                <div class="item">提现总额合计：{{withdrawal_amount_total}}</div>
                <div class="item">奖励金剩余金额合计：{{remain_bonus_total}}</div>
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="activation_time" label="注册时间" width="150"></el-table-column>
                <el-table-column prop="level_name" label="会员等级"></el-table-column>
                <el-table-column prop="mobile" label="会员手机号"></el-table-column>
                <el-table-column prop="vip_card" label="会员卡号"></el-table-column>
                <el-table-column prop="username" label="会员姓名"></el-table-column>
                <el-table-column prop="invitation_mobile" label="邀请人手机号"></el-table-column>
                <el-table-column prop="first_level_num" label="一级客户"></el-table-column>
                <el-table-column prop="second_level_num" label="二级客户"></el-table-column>
                <el-table-column prop="third_level_num" label="三级客户"></el-table-column>
                <el-table-column prop="bonus" label="奖励金总额"></el-table-column>
                <el-table-column prop="withdrawal_amount" label="提现总额"></el-table-column>
                <el-table-column prop="remain_bonus" label="奖励金剩余金额"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="toCheckDetail(scope.row)">客户明细</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>

        <!-- 客户明细面板 -->
        <div class="detail-panel" v-show="showDetail">
            <h3>客户明细</h3>
            <div class="total-txt">所属会员：{{detail_mobile}} {{detail_username}}</div>
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="会员等级">
                    <el-select v-model="detail_form.fiss_level" filterable clearable placeholder="请选择会员等级">
                        <el-option v-for="item in vip_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入内容" v-model="detail_form.content">
                        <el-select class="el-slot-select" v-model="detail_form.select" slot="prepend" placeholder="请选择">
                            <el-option label="会员手机号" value="vip_mobile"></el-option>
                            <el-option label="会员卡号" value="vip_card"></el-option>
                            <el-option label="会员姓名" value="vip_name"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="客户类型">
                    <el-select v-model="detail_form.fission_level" filterable clearable placeholder="请选择客户类型">
                        <el-option v-for="item in fission_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="detailListQuery">查询</el-button>
                    <el-button @click="detailListExport">导出</el-button>
                    <el-button @click="showDetail=false">返回</el-button>
                </el-form-item>
            </el-form>
            <el-row class="total-txt">
                <div class="item">累计消费金额合计：{{detail_consumption_total}}</div>
                <div class="item">累计带来奖励金额合计：{{detail_bonus_total}}</div>
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="detail_table">
                <el-table-column prop="activation_time" label="注册时间" width="150"></el-table-column>
                <el-table-column prop="fiss_level_name" label="会员等级"></el-table-column>
                <el-table-column prop="fiss_mobile" label="会员手机号"></el-table-column>
                <el-table-column prop="fiss_vip_card" label="会员卡号"></el-table-column>
                <el-table-column prop="fiss_username" label="会员姓名"></el-table-column>
                <el-table-column prop="fission_level_name" label="客户类型"></el-table-column>
                <el-table-column prop="consumption" label="累计消费金额"></el-table-column>
                <el-table-column prop="bonus" label="累计带来奖励金额"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="detail_page"
                :total="detail_total"
                @current-change="getDetailList">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'hlbgx-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                vip_list: [],
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    content: '',
                    select: 'vip_mobile',
                    level: '',
                    invitation_mobile: '',
                },
                bonus_total: 0,
                remain_bonus_total: 0,
                withdrawal_amount_total: 0,
                list_table: [],
                list_page: 1,
                list_total: 0,
                
                showDetail: false,
                detail_mobile: '',
                detail_username: '',
                fission_list: [{
                    id: '0',
                    name: '全部'
                }, {
                    id: '1',
                    name: '一级客户'
                }, {
                    id: '2',
                    name: '二级客户'
                }, {
                    id: '3',
                    name: '三级客户'
                }],
                detail_form: {
                    shop_id: '',
                    vip_id: '', //会员id
                    content: '',
                    select: 'vip_mobile',
                    fiss_level: '', // 会员等级
                    fission_level: '0' // 客户类型 1~3级 全部传0, 
                },  
                detail_table: [],
                detail_page: 1,
                detail_total: 0,
                detail_consumption_total: 0,
                detail_bonus_total: 0,
            }
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.innitDate();
            
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getVipLevelCombo()
                this.getList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },

            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            changeShop(val) {
                if (!!val) {
                    this.setShopDefaultTime(val)
                }
            },

            // 获取会员卡等级
            getVipLevelCombo: function() {
                const _this = this;

                Vue.axios.post('Vip/getVipLevelCombo', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.vip_list = res.data.response.result;
                        _this.vip_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
                const _this = this;

                _this.loading = true;
                let vip_card = "",
                    username = "",
                    mobile = "";
                if(_this.list_form.select == 'vip_card') {
                    vip_card = _this.list_form.content;
                } else if(_this.list_form.select == 'vip_name') {
                    username = _this.list_form.content;
                } else if(_this.list_form.select == 'vip_mobile') {
                    mobile = _this.list_form.content;
                }
                Vue.axios.post('FinanceReport2/getVipFissionDataList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.list_form.start_time,
                            "end_time": _this.list_form.end_time,
                            "shop_id": _this.list_form.shop_id,
                            "vip_card": vip_card,
                            "username": username,
                            "mobile": mobile,
                            "level": _this.list_form.level,
                            "invitation_mobile": _this.list_form.invitation_mobile
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.list_total = Number(res.data.response.result.data.total);
                            _this.bonus_total = res.data.response.result.data.bonus_total
                            _this.remain_bonus_total = res.data.response.result.data.remain_bonus_total
                            _this.withdrawal_amount_total = res.data.response.result.data.withdrawal_amount_total;
                        }
                        _this.list_table = res.data.response.result.data.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 查询
            listQuery() {
                this.list_page = 1
                this.getList(this.list_page);
            },

            listExport: function() {
                let vip_card = "",
                    username = "",
                    mobile = "";
                if(this.list_form.select == 'vip_card') {
                    vip_card = this.list_form.content;
                } else if(this.list_form.select == 'vip_name') {
                    username = this.list_form.content;
                } else if(this.list_form.select == 'vip_mobile') {
                    mobile = this.list_form.content;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/exportVipFissionDataList" +
                    "?start_time=" + this.list_form.start_time +
                    "&end_time=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&vip_card=" + vip_card +
                    "&username=" + username +
                    "&mobile=" + mobile +
                    "&level=" + this.list_form.level +
                    "&invitation_mobile=" + this.list_form.invitation_mobile;
                layer.msg("导出成功！");
            },

            toCheckDetail(row) {
                this.detail_form = {
                    shop_id: this.list_form.shop_id,
                    vip_id: row.vip_id, //会员id
                    content: '',
                    select: 'vip_mobile',
                    fiss_level: '', 
                    fission_level: '0', // 客户类型 1~3级 全部传0
                }
                this.detail_mobile = row.mobile
                this.detail_username = row.username
                this.showDetail = true
                this.detail_page = 1
                this.getDetailList(this.detail_page)
            },

            getDetailList(page) {
                const _this = this;

                _this.loading = true;
                let vip_card = "",
                    username = "",
                    mobile = "";
                if(_this.detail_form.select == 'vip_card') {
                    vip_card = _this.detail_form.content;
                } else if(_this.detail_form.select == 'vip_name') {
                    username = _this.detail_form.content;
                } else if(_this.detail_form.select == 'vip_mobile') {
                    mobile = _this.detail_form.content;
                }
                Vue.axios.post('FinanceReport2/getVipFissionRelationList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.detail_form.shop_id,
                            "vip_id": _this.detail_form.vip_id,
                            "fiss_vip_card": vip_card,
                            "fiss_username": username,
                            "fiss_mobile": mobile,
                            "fiss_level": _this.detail_form.fiss_level,
                            "fission_level": _this.detail_form.fission_level
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.detail_total = Number(res.data.response.result.data.total);
                            _this.detail_bonus_total = res.data.response.result.data.bonus_total
                            _this.detail_consumption_total = res.data.response.result.data.consumption_total
                        }
                        _this.detail_table = res.data.response.result.data.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 查询
            detailListQuery() {
                this.detail_page = 1
                this.getDetailList(this.detail_page);
            },

            detailListExport: function() {
                let vip_card = "",
                    username = "",
                    mobile = "";
                if(this.detail_form.select == 'vip_card') {
                    vip_card = this.list_form.content;
                } else if(this.detail_form.select == 'vip_name') {
                    username = this.detail_form.content;
                } else if(this.detail_form.select == 'vip_mobile') {
                    mobile = this.detail_form.content;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/exportVipFissionRelationList" +
                    "?vip_id=" + this.detail_form.vip_id +
                    "&shop_id=" + this.detail_form.shop_id +
                    "&fiss_vip_card=" + vip_card +
                    "&fiss_username=" + username +
                    "&fiss_mobile=" + mobile +
                    "&fiss_level=" + this.detail_form.fiss_level +
                    "&fission_level=" + this.detail_form.fission_level;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .total-txt {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .item {
            margin-right: 40px;
        }
    }

    .detail-panel {
        h3 {
            margin-bottom: 10px;
        }
    }
</style>